import { ProjectDetails } from "./projectdetail.service";

export interface ProjectDetail{
    id:string;
    title:string;
    cover_image:string;
    short_desc:string;
    start_year:string;
    end_year:string;
    keywords:string[];
    abstract:string;

}

export enum Projects{
    Human_Drone="drone",
    SAFA="safa",
    Human_AI="hai",
    Sentiment_Analysis="sentiment"
}